/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var brightsmith_core_1 = require("brightsmith-core");

var HIGHEST_ZINDEX = 999;
var Helper = {
  getFullImageUrl: function getFullImageUrl(img, baseUrl, zIndex) {
    var urlObj = {
      url: brightsmith_core_1.Util.cleanUrl("".concat(baseUrl, "/").concat(img))
    };

    if (typeof zIndex === 'number') {
      urlObj.zIndex = zIndex;
    } else if (typeof zIndex == 'string') {
      urlObj.zIndex = parseInt(zIndex);
    } else if (zIndex) {
      urlObj.zIndex = zIndex[img];
    }

    return urlObj;
  },
  getRenderPathFromTemplate: function getRenderPathFromTemplate(env, model, view) {
    var _a, _b, _c, _d, _e;

    var templateMap = {
      '{bucket}': ((_a = model.env) === null || _a === void 0 ? void 0 : _a.BRIGHTSMITH_S3_BUCKET_PATH) || env.BRIGHTSMITH_S3_BUCKET_PATH,
      '{data}': ((_b = model.env) === null || _b === void 0 ? void 0 : _b.BRIGHTSMITH_S3_DATA_FOLDER) || env.BRIGHTSMITH_S3_DATA_FOLDER,
      '{renders}': ((_c = model.env) === null || _c === void 0 ? void 0 : _c.BRIGHTSMITH_S3_RENDERS_FOLDER) || env.BRIGHTSMITH_S3_RENDERS_FOLDER,
      '{model}': ((_d = model.paths) === null || _d === void 0 ? void 0 : _d.renders) || model.slug || model.id,
      '{view}': view
    };
    var template = ((_e = model.env) === null || _e === void 0 ? void 0 : _e.BRIGHTSMITH_RENDER_PATH_TEMPLATE) || env.BRIGHTSMITH_RENDER_PATH_TEMPLATE;
    var path = brightsmith_core_1.Util.replaceStringTemplate(template, templateMap);
    return path;
  },
  getUrls: function getUrls(env, activeView, model) {
    var properties = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var urls = [];

    if (!model || Object.keys(properties).length === 0) {
      return [];
    }

    var display = model.display,
        _model$views = model.views,
        views = _model$views === void 0 ? [] : _model$views;
    var view = views.length ? views[activeView] : '';
    var basePath = Helper.getRenderPathFromTemplate(env, model, view);

    if (display === null || display === void 0 ? void 0 : display.baseRenders) {
      display.baseRenders.forEach(function (base) {
        return urls.push(Helper.getFullImageUrl(base, basePath, 0));
      });
    }

    Object.values(properties).forEach(function (property) {
      var render = property.render;

      if (render) {
        var renders = Array.isArray(render) ? render : [render];
        renders.forEach(function (img) {
          var zIndex = Helper.getZIndex(property, activeView);
          urls.push(Helper.getFullImageUrl(img, basePath, zIndex));
        });
      }
    });
    return urls.sort(function (a, b) {
      var _a, _b;

      var aIndex = (_a = a.zIndex) !== null && _a !== void 0 ? _a : HIGHEST_ZINDEX;
      var bIndex = (_b = b.zIndex) !== null && _b !== void 0 ? _b : HIGHEST_ZINDEX;
      return aIndex - bIndex;
    }).map(function (url) {
      return url.url;
    });
  },
  getZIndex: function getZIndex(property, activeView) {
    var _a;

    var zIndex = ((_a = property.display) === null || _a === void 0 ? void 0 : _a.zIndex) || 0;

    if (['string', 'number'].includes(typeof zIndex)) {
      return zIndex;
    } else {
      return zIndex[activeView];
    }
  }
};
exports.default = Helper;